import React from "react"
import {QueryClient, QueryClientProvider} from "@tanstack/react-query"
import {RouterProvider} from "@tanstack/react-router"
import {router} from "@/routing/router"
import useAuth from "@/library/auth/_hook.auth"

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            //gcTime: 1000 * 60 * 60 * 24,
            refetchOnReconnect: true,
            refetchOnWindowFocus: false,
            staleTime: Infinity
        }
    }
})

export default function RootComponent() {
    const auth = useAuth()

    return <QueryClientProvider client={queryClient}>
        <RouterProvider router={router({queryClient, auth})}/>
    </QueryClientProvider>
}
